export default __webpack_public_path__ + "../img/7b9f536eb9a4e7920afb7a8b0ae95325.png";